export const foodIcons = [
  'restaurant',
  'local_bar',
  'local_cafe',
  'local_dining',
  'local_drink',
  'local_pizza',
  'restaurant_menu',
  'cake'
]

export const activityIcons = [
  'local_activity',
  'local_library',
  'local_mall',
  'local_movies',
  'local_see',
  'terrain',
  'palette',
  'music_note',
  'beach_access',
  'pool',
  'casino',
  'spa',
  'golf_course'
]

export const activitySvg =
  'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z'

export const restaurantSvg =
  'M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z'

export const barSvg =
  'M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z'



// WEBPACK FOOTER //
// ./src/components/SlotMachine/icons.js